export interface SearchResult {
  id: string;
  type: "paciente" | "agendamento";
  title: string;
  subtitle?: string;
  data?: any;
}

export const useGlobalSearch = (_query: string) => {
  return { results: [] as SearchResult[], isLoading: false };
};
